import { call, put, takeEvery } from 'redux-saga/effects';
import {
  addOemRequest,
  addOemSuccess,
  addOemFailure,
  getOemRequest,
  getOemSuccess,
  getOemFailure,
  getScanTypesSuccess,
  getScanTypesFailure,
  getOemNamesSuccess,
  getOemNamesFailure,
  resendVerificationEmailSuccess,
  resendVerificationEmailFailure
} from '../actions/oemActions';
import { oemApi } from '../../api/oemApi';
import { toast } from 'react-toastify';

function* addOemSaga(action) {
  try {
    yield put(addOemRequest());
    const response = yield call(oemApi.addPartner, action.payload);
    yield put(addOemSuccess(response.data));
    toast.success('OEM Partner created successfully!');
    const refreshParams = action.payload.refreshParams || { limit: 10, page: 1 };
    yield put({ type: 'GET_OEM_SAGA', payload: refreshParams });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to add OEM partner';
    yield put(addOemFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* getOemSaga(action) {
  try {
    yield put(getOemRequest());
    const response = yield call(oemApi.getPartners, action.payload);
    yield put(getOemSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch OEM partners';
    yield put(getOemFailure(errorMessage));
  }
}

function* editOemSaga(action) {
  try {
    yield put({ type: 'EDIT_OEM_REQUEST' });
    const response = yield call(oemApi.editPartner, action.payload);
    yield put({ type: 'EDIT_OEM_SUCCESS', payload: response.data });
    toast.success('OEM Partner updated successfully!');
    const refreshParams = action.payload.refreshParams || { limit: 10, page: 1 };
    yield put({ type: 'GET_OEM_SAGA', payload: refreshParams });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update OEM partner';
    yield put({ type: 'EDIT_OEM_FAILURE', payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* deleteOemSaga(action) {
  try {
    yield put({ type: 'DELETE_OEM_REQUEST' });
    const response = yield call(oemApi.deletePartner, action.payload.id || action.payload);
    yield put({ type: 'DELETE_OEM_SUCCESS', payload: action.payload.id || action.payload });
    toast.success('OEM Partner deleted successfully!');
    if (response.status === 200) {
      const refreshParams = action.payload.refreshParams || { limit: 10, page: 1 };
      yield put({ type: 'GET_OEM_SAGA', payload: refreshParams });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete OEM partner';
    yield put({ type: 'DELETE_OEM_FAILURE', payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* changeOemStatusSaga(action) {
  try {
    yield put({ type: 'CHANGE_OEM_STATUS_REQUEST' });
    const response = yield call(oemApi.changeStatus, action.payload);
    yield put({ type: 'CHANGE_OEM_STATUS_SUCCESS', payload: response.data });
    toast.success('Status updated successfully!');
    // Preserve current filter parameters when refreshing
    const refreshParams = action.payload.refreshParams || { limit: 10, page: 1 };
    yield put({ type: 'GET_OEM_SAGA', payload: refreshParams });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update status';
    yield put({ type: 'CHANGE_OEM_STATUS_FAILURE', payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* getScanTypesSaga() {
  try {
    yield put({ type: 'GET_SCAN_TYPES_REQUEST' });
    const response = yield call(oemApi.getScanTypes);
    yield put(getScanTypesSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch scan types';
    yield put(getScanTypesFailure(errorMessage));
  }
}

function* getOemNamesSaga() {
  try {
    yield put({ type: 'GET_OEM_NAMES_REQUEST' });
    const response = yield call(oemApi.getOemNames);
    yield put(getOemNamesSuccess(response));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch OEM names';
    yield put(getOemNamesFailure(errorMessage));
  }
}

function* resetOemPasswordSaga(action) {
  try {
    yield put({ type: 'RESET_OEM_PASSWORD_REQUEST' });
    const response = yield call(oemApi.resetPassword, action.payload);
    yield put({ type: 'RESET_OEM_PASSWORD_SUCCESS', payload: response });
    toast.success('Password reset successfully and email sent!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to reset password';
    yield put({ type: 'RESET_OEM_PASSWORD_FAILURE', payload: errorMessage });
    toast.error(errorMessage);
  }
}

function* resendVerificationEmailSaga(action) {
  try {
    yield put({ type: 'RESEND_VERIFICATION_EMAIL_REQUEST' });
    const response = yield call(oemApi.resendVerificationEmail, action.payload);
    yield put(resendVerificationEmailSuccess(response));
    toast.success('Verification email sent successfully!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to send verification email';
    yield put(resendVerificationEmailFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* oemSaga() {
  yield takeEvery('ADD_OEM_SAGA', addOemSaga);
  yield takeEvery('GET_OEM_SAGA', getOemSaga);
  yield takeEvery('EDIT_OEM_SAGA', editOemSaga);
  yield takeEvery('DELETE_OEM_SAGA', deleteOemSaga);
  yield takeEvery('CHANGE_OEM_STATUS_SAGA', changeOemStatusSaga);
  yield takeEvery('RESET_OEM_PASSWORD_SAGA', resetOemPasswordSaga);
  yield takeEvery('GET_SCAN_TYPES_SAGA', getScanTypesSaga);
  yield takeEvery('GET_OEM_NAMES_SAGA', getOemNamesSaga);
  yield takeEvery('RESEND_VERIFICATION_EMAIL_SAGA', resendVerificationEmailSaga);
}

export default oemSaga;